module.exports = "fragment BannerFragment on ComponentSectionsBannerSlider {\n  __typename\n  slides {\n    ...SlideType\n  }\n}\n"